// Renames the style attribute of every tag in the markup to newName. A quoted attribute value is
// matched whole first, so a " style=" inside it is left as it is.
export default function renameStyleAttributes(html, newName) {
  return html.replace(/<[a-z][^<>]*>/gi, (tag) => tag.replace(/("[^"]*"|'[^']*')|\sstyle=/gi, (match, quotedValue) => {
    if (quotedValue) {
      return quotedValue;
    }

    return ` ${newName}=`;
  }));
}
